import React from 'react';
import { View } from 'react-native';

// Web-compatible KeyboardProvider component
// On web, keyboard handling is typically managed by the browser
export const KeyboardProvider = ({ children, ...props }) => {
  return <View {...props}>{children}</View>;
};

// Mock hook for web - returns default keyboard info since web doesn't need native keyboard handling
export const useKeyboardContext = () => ({
  keyboard: {
    height: 0,
    progress: 0,
  },
  focused: false,
});

// Mock hook for web keyboard animation
export const useKeyboardAnimation = () => ({
  height: { value: 0 },
  progress: { value: 0 },
});

// Mock hook for web keyboard handler
export const useKeyboardHandler = (handlers) => {
  // On web, return no-op handlers since keyboard events are handled differently
  return {};
};

// Mock function for web
export const KeyboardEvents = {
  addListener: () => ({ remove: () => {} }),
};

// Export default as KeyboardProvider for compatibility
export default KeyboardProvider;
